import React from 'react';
//STYLES

import './styles/Banner.css';

export default function Banner() {
	return (
		<div className="Banner-section">
			<div className="container">
				<h2>Simplify how your team works today</h2>
				<button>Get Started</button>
			</div>
		</div>
	);
}
